import axios from "axios";
import config from "./config";
import { interceptor } from "./interceptor";


const ax = axios.create({
  baseURL: config.apiURL,
});


// interceptor(apiClient);

// export  default apiClient;


export {  ax };

interceptor(ax);